import { isStaff, ROLE_MPS_ADMIN } from "../security/roles";
import StorageService from "../services/storageService";
import { API_URL_KEY, http } from "../utils/http";
import Env from "./env";
import { parseURLQueryParams } from "../utils/utils";

export const REACT_APP_ENV = process.env.REACT_APP_ENV || "development";
export const API_CLIENT_ID = process.env.REACT_APP_API_CLIENT_ID;
export const API_CLIENT_SECRET = process.env.REACT_APP_API_CLIENT_SECRET;

// export const API_DOMAIN = process.env.REACT_APP_MYP_API_URL
//   ? process.env.REACT_APP_MYP_API_URL
//   : "testservice.mypatientspace.com";
// export const DEFAULT_API_URL = "https://testservice.mypatientspace.com";
// export const API_URL = "https://" + API_DOMAIN;
// export const API_URL = "http://localhost:8080";

export const API_ENDPOINTS = {
  trafficLightConfig: "/api/artifact/trafficlightconfig",
  facilityMessages: "/api/facilityMessages",
  apiVersion: "/api/a/version",
  saveCustomHomeConfig: (patientTypeId) =>
    `api/artifact/patienttypes/${patientTypeId}/screens`,
  getCustomHomeConfig: (patientTypeId, screenType) =>
    `api/artifact/patienttypes/${patientTypeId}/screenConfig?screenType=${screenType}`,
  sendStaffConversation: (patientId, messageId) =>
    `api/staff/patients/${patientId}/messages/${messageId}/conversation`,
  getStaffMessage: (patientId, messageId) =>
    `api/staff/patients/${patientId}/messages/${messageId}`,
  getComorbidityTemplates: (patientTypeId) =>
    `/api/artifact/comorbidityTemplates?patientTypeId=${patientTypeId}&page=0&size=100`,
  postComorbidityTemplate: () => `/api/artifact/comorbidityTemplates`,
  deleteComorbidityTemplate: (comorbidityTemplateId) =>
    `/api/artifact/comorbidityTemplates/${comorbidityTemplateId}`,
  getUIWidgets: (patientTypeId) =>
    `/api/artifact/uiwidgets?patientTypeId=${patientTypeId}&size=999`,
  createUIWidget: () => `/api/artifact/uiwidgets`,
  getUIWidget: (widgetId) => `/api/artifact/uiwidgets/${widgetId}`,
  updateUIWidget: (widgetId) => `/api/artifact/uiwidgets/${widgetId}`,
  deleteUIWidget: (widgetId) => `/api/artifact/uiwidgets/${widgetId}`,
  locateUser: `/api/signup/locateUser`,
  get_token: "/oauth/token",
  get_user_info: "/api/users/userDetails",
  acceptInvite: () => `/api/signup/acceptInvite`,
  fetchSpaceDetailsFromInviteCode: () =>
    `/api/signup/fetchSpaceDetailsFromInviteCode/`,
  acceptTerms: () => `/api/signup/acceptTermsAndConditions`,
  confirmationCode: () => `/api/signup/activateWith2FACode`,
  confirmationCodeWithTerms: () => `/api/signup/activateWithTerms`,
  setCredentials: () => `/api/signup/setLoginCredentials`,
  getSpaceInfo: () => "/api/space",
  getFacilityInfo: () => "/api/admin/facility",
  getAllFacilities: () => "/api/mpsadmin/facilities",
  loadOrganization: (id) => `/api/mpsadmin/facilities/${id}`,
  updateFacility: (role, id) =>
    role === ROLE_MPS_ADMIN
      ? `/api/mpsadmin/facilities/${id}`
      : `/api/admin/facility`,
  addFacility: () => "/api/mpsadmin/facilities/",
  loadAdmins: (id) => `/api/mpsadmin/facilities/${id}/admin`,
  cloneFacility: (id) => `/api/mpsadmin/facilities/${id}/clone`,
  inviteAdmin: (orgId, withoutInvite) =>
    withoutInvite
      ? `/api/mpsadmin/facilities/${orgId}/admin/unauth`
      : `/api/mpsadmin/facilities/${orgId}/admin`,
  inviteCrossFacilityUser: (primaryFacilityId) =>
    `/api/mpsadmin/cross-facility-users?primaryFacilityId=${encodeURIComponent(primaryFacilityId)}`,
  listCrossFacilityUsers: () => `/api/mpsadmin/cross-facility-users`,
  deleteCrossFacilityUser: (staffId) =>
    `/api/mpsadmin/cross-facility-users/${encodeURIComponent(staffId)}`,
  deviceDefns: () => `/api/mpsadmin/devicedefns`,
  deviceDefn: (id) => `/api/mpsadmin/devicedefns/${encodeURIComponent(id)}`,
  // Staff-accessible view of the same device definitions — the /api/mpsadmin/**
  // path above is restricted to MPS admins server-side.
  artifactDeviceDefns: () => `/api/artifact/devicedefns`,
  devices: () => `/api/artifact/devices`,
  device: (id) => `/api/artifact/devices/${encodeURIComponent(id)}`,
  deleteAdmin: (orgId, id) => `/api/mpsadmin/facilities/${orgId}/admin/${id}`,
  loadStaff: () => `/api/org/staff/`,
  loadAllStaffForStaff: () => `/api/staff/staffs`,
  loadOneStaff: (staffId) => `/api/org/v1/staff/${staffId}`,
  inviteStaff: (withoutInvite) =>
    withoutInvite ? `/api/org/staff/withoutinvite` : `/api/org/staff`,
  deleteStaff: (staffId) => `/api/org/staff/${staffId}`,
  editStaff: (staffId) => `/api/org/staff/${staffId}`,
  loadPatients: () => "/api/staff/v1/getpatients",
  loadPatientsCount: () => "/api/staff/v1/getpatients/count",
  loadPatient: (patientId) =>
    `/api/staff/patients/${
      patientId // loadPatients: () => "/api/staff/patients/",
    }/details`,
  inviteAdminUser: (patientId, withoutInvite) =>
    withoutInvite
      ? `/api/staff/patients/${patientId}/adminmember/withoutinvite`
      : `/api/staff/patients/${patientId}/adminmember/`,
  inviteSpaceMember: (patientId, withoutInvite) =>
    withoutInvite
      ? `/api/staff/patients/${patientId}/member/withoutinvite`
      : `/api/staff/patients/${patientId}/member/`,
  getSpaceDetails: () => `/api/fetchSpaceDetailsForInviteCode`,
  addPatient: (withoutInvite) =>
    withoutInvite ? "/api/staff/patients/withoutinvite" : "/api/staff/patients",
  addPatientWithoutInvite: () => "/api/staff/patients/withoutinvite",
  deletePatient: (patientId) => `/api/staff/patients/${patientId}`,
  getSpeechToken: () => `/api/artifact/speechToken`,
  enhanceTranscript: () => `/api/staff/enhanceTranscript`,
  generateSmartNote: (patientId, templateId) =>
    `/api/artifact/${patientId}/smartNote/${templateId}`,
  generateSmartDocument: (patientId, templateId) =>
    `/api/staff/patients/${patientId}/smartDocument/${templateId}`,
  saveSmartDocument: (patientId) =>
    `/api/staff/patients/${patientId}/saveSmartDocument`,
  // Save Edits feature endpoints
  saveGeneratedDocument: (patientId) =>
    `/api/staff/patients/${patientId}/generatedDocument`,
  loadDraftDocuments: (patientId, page = 0, size = 20) =>
    `/api/staff/patients/${patientId}/generatedDocuments?status=DRAFT&page=${page}&size=${size}`,
  deleteGeneratedDocument: (patientId, docId) =>
    `/api/staff/patients/${patientId}/generatedDocument/${docId}`,
  finalizeGeneratedDocument: (patientId, docId) =>
    `/api/staff/patients/${patientId}/generatedDocument/${docId || "_new"}/finalize`,
  restoreDocumentVersion: (patientId, docId, versionNumber) =>
    `/api/staff/patients/${patientId}/generatedDocument/${docId}/versions/${versionNumber}/restore`,
  loadPatientTypesTemplate: () => `/api/artifact/mpstemplate`,
  loadPatientTypes: () => `/api/artifact/patienttypes`,
  loadSinglePatientType: (id) => `/api/artifact/patienttypes/${id}`,
  topicsFromMasterData: (id, type) =>
    `/api/artifact/masterdata/topics?${
      id ? `pTypeid=${id}` : ""
    }&topicType=${type}`,
  addPatientType: () => `/api/artifact/patienttypes`,
  editPatientType: (id) => `/api/artifact/patienttypes/${id}`,
  getScreenConfig: (patientTypeId, screenType) =>
    `/api/artifact/patienttypes/${patientTypeId}/screenConfig?screenType=${screenType}`,
  getScreenConfigStaff: (patientTypeId, screenType) =>
    `/api/artifact/screenConfig?screenType=${screenType}${
      patientTypeId ? `&patientTypeId=${patientTypeId}` : ""
    }`,
  addProfileAttribute: (profileId) =>
    `/api/artifact/patienttypes/${profileId}/attributes`,
  updateProfileAttribute: (profileId, attributeId) =>
    `/api/artifact/patienttypes/${profileId}/attributes/${attributeId}`,
  deleteProfileAttribute: (profileId, attributeId) =>
    `/api/artifact/patienttypes/${profileId}/attributes/${attributeId}`,
  attributeWhereUsed: (patientTypeId, attributeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/attributes/${attributeId}/where-used`,
  addProfileMarkup: (profileId) =>
    `/api/artifact/patienttypes/${profileId}/screens`,
  loadMembers: (patientId) => `/api/staff/patients/${patientId}/members`,
  update_patient: "/api/patients/",
  addStatus: (role, patientId) =>
    isStaff(role)
      ? `/api/staff/patients/${patientId}/status`
      : `/api/patient/status`,
  addStatusFromSurvey: (patientId, surveyId) =>
    `/api/staff/patients/${patientId}/assignSurvey/${surveyId}`,
  addLibraryStatus: (patientId, libraryId) =>
    `/api/staff/patients/${patientId}/assignLibrary/${libraryId}`,
  addConsentDocumentStatus: (patientId, consentId) =>
    `/api/staff/patients/${patientId}/assignConsent/${consentId}`,
  loadStatuses: (role, patientId) =>
    isStaff(role)
      ? `/api/staff/patients/${patientId}/artifacts?artifactType=STATUSES_NEW`
      : `/api/patient/artifacts?artifactType=STATUSES_NEW`,
  loadStaffNotes: (patientId) =>
    `/api/staff/patients/${patientId}/artifacts?artifactType=STAFF_NOTES`,
  addStatusTemplate: () => `/api/artifact/messagetemplates`,
  previewDocument: () => `/api/artifact/messagetemplates/preview`,
  loadStatusTemplates: () => `/api/artifact/messagetemplates`,
  loadTemplateParameters: (type) =>
    `/api/artifact/messageparameters?messageType=${type}&page=0&size=100`,
  loadSurveys: () => "/api/artifact/surveys/",
  loadSurvey: (surveyId) => "/api/artifact/surveys/" + surveyId,
  addSurvey: () => "/api/artifact/surveys/",
  fileUpload: () => "/api/uploadFiles",
  loadContentLibrary: () => "/api/artifact/libraries",
  loadContentLibraryByName: (name) => `/api/libraries?name=${name}`,
  addLibraryContent: () => "/api/artifact/libraries",
  prepareLibraryAudioScript: (libraryId) =>
    `/api/artifact/libraries/${libraryId}/audio/script`,
  generateLibraryAudioFromScript: (libraryId) =>
    `/api/artifact/libraries/${libraryId}/audio/generate`,
  getLibraryAudioJobStatus: (libraryId, pendingProcessId) =>
    `/api/artifact/libraries/${libraryId}/audio/jobs/${pendingProcessId}`,
  generateLibraryTranslations: (patientTypeId) =>
    `/api/artifact/libraries/${patientTypeId}/generateTranslations`,
  loadTopics: () => "/api/artifact/librarytopics",
  loadArticle: (articleId) => "/api/artifact/libraries/" + articleId,
  loadArticlePatient: (articleId) => "/api/libraries/" + articleId,
  addLibraryTopic: () => "/api/artifact/librarytopics",
  loadTopic: (topicId) => "/api/artifact/librarytopics/" + topicId,
  addInfoPanel: (patientTypeId, isImport) =>
    `/api/artifact/patienttypes/${patientTypeId}/infopanel${
      isImport ? "?importContent=true" : ""
    }`,
  predefinedItems: (patientTypeId) =>
    "/api/artifact/patienttypes/" + patientTypeId + "/predefineditems",
  contentUrl: (fileKey) => "/api/content?fileKey=" + fileKey,
  loadPatientSurveys: (patientId) =>
    "/api/staff/patients/" +
    patientId +
    "/artifacts?artifactType=SURVEY_RESPONSES&page=0&size=100",
  loadAllPackages: () => "/api/mpsadmin/packages",
  loadProvisionedPackages: () => "/api/artifact/provisionedPackages/",
  carePlan: () => "/api/artifact/careplans/",
  carePlanById: (id) => "/api/artifact/careplans/" + id,
  carePlansByPatientType: (patientTypeId) =>
    "/api/artifact/careplans/patienttypes/" + patientTypeId,
  carePlanTemplates: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/careplantemplates`,
  carePlansByPatient: (patientId) =>
    "/api/staff/patients/" + patientId + "/careplanView",
  carePlanAdherenceHistory: (patientId) =>
    "/api/staff/patients/" + patientId + "/careplanView?include-adherence-history=true",
  carePlansByPatientForStaff: (patientId) =>
    "/api/staff/patients/" + patientId + "/careplanView?action-for=STAFF",
  patientCPForEdit: (patientId) =>
    "/api/staff/patients/" + patientId + "/careplan",
  assignCarePlanToPatient: (patientId) =>
    "/api/staff/patients/" + patientId + "/assignCarePlan",
  changePatientCarePlan: (patientId, carePlanId) =>
    `/api/staff/patients/${patientId}/assignCarePlan/${carePlanId}`,
  expressions: (patientTypeId) =>
    `/api/artifact/careplans/expressions/patient-type/${
      patientTypeId // expressions: () => "/api/artifact/careplans/expressions",
    }`,
  expressionsForMps: () => "/api/mpsadmin/careplans/expressions",
  consentDocuments: () => "/api/artifact/consentDocuments",
  consultants: "/api/consultants",
  messageTemplate: (templateId) =>
    "/api/artifact/messagetemplates/" + templateId,
  getPatientProfile: (patientId) =>
    "/api/staff/patients/" + patientId + "/profile",
  loadPatientDocuments: (patientId) =>
    `/api/staff/patients/${patientId}/artifacts?artifactType=PATIENT_DOCUMENTS`,
  loadPatientDevices: (patientId) =>
    `/api/staff/patients/${patientId}/artifacts?artifactType=DEVICES`,
  updatePatientProfileAttribute: (patientId) =>
    `/api/staff/patients/${patientId}/profile/attributes`,
  updatePatientProfileAttributesMulti: (patientId) =>
    `/api/staff/patients/${patientId}/profile/attributes/multi`,
  loadMyPatients: "/api/staff/mypatients",
  uiAttributeDataFields: "/api/artifact/attributeDataFields?size=500",
  uiAttributeDataFieldsMPS: "/api/mpsadmin/attributeDataFields",
  forgotPassword: "/api/signup/forgotPasswordResetRequest",
  resetPassword: "/api/signup/forgotPasswordSetNewPassword",
  uploadPatientProfilePhoto: (patientId) =>
    `/api/staff/patients/${patientId}/photo`,
  addMember: (withoutInvite, patientId) =>
    withoutInvite
      ? "/api/staff/patients/" + patientId + "/member/withoutinvite"
      : "/api/staff/patients/" + patientId + "/member/",
  addAdminMember: (withoutInvite, patientId) =>
    withoutInvite
      ? "/api/staff/patients/" + patientId + "/adminmember/withoutinvite"
      : "/api/staff/patients/" + patientId + "/adminmember/",
  loadStaffProfile: "/api/staff/",
  loadFacilityAdminProfile: "/api/admin/",
  loadMpsAdminProfile: "/api/mpsadmin/",
  removeMember: (patientId, memberId) =>
    "/api/staff/patients/" + patientId + "/members/delete?id=" + memberId,
  editMember: (patientId, memberId) =>
    `/api/staff/patients/${patientId}/member/${memberId}/details`,
  createMPSPackage: (facilityId, patientTypeId) =>
    `/api/mpsadmin/facilities/${
      facilityId // createMPSPackage: `/api/mpsadmin/mpspackages/`,
    }/patientTypes/${patientTypeId}/mpspackages`,
  loadMPSPackage: (packageId) => `/api/mpsadmin/mpspackages/${packageId}`,
  proceduresList: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/attributes/name/MPS_PATIENT_PROCEDURE`,
  assessmentStats: "/api/artifact/v1/getassessments/",
  patientTypesForPackageForImport: (packageId) =>
    `/api/mpsadmin/patientTypesForPackageId?packageId=${
      packageId // assessmentStats: "/api/artifact/getassessments",
    }`,
  patientTypesForPackageForExport: (packageId) =>
    `/api/mpsadmin/allPatientTypesForPackageId?packageId=${packageId}`,
  fetchCGMSurveyData: (patientId, fromDate, toDate, surveyName) => {
    let url = `/api/staff/patients/${patientId}/cgmSurveyData`;
    const params = new URLSearchParams();
    if (fromDate && toDate) {
      fromDate = convertDateFormat(fromDate);
      toDate = convertDateFormat(toDate);
      params.append("fromDate", fromDate);
      params.append("toDate", toDate);
    }
    if (surveyName) {
      params.append("surveyName", surveyName);
    }
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
    return url;
  },
  importFromFacility: (packageId) =>
    `/api/mpsadmin/mpspackages/${
      packageId //   `/api/mpsadmin/mpspackages/${packageId}/updatefromFacilities/${facilityId}/patientTypes/${patientTypeId}`, // importFromFacility: (packageId, facilityId, patientTypeId) =>
    }/updateFromFacilities`,
  exportToFacility: (packageId, facilityId, patientTypeId) =>
    `/api/mpsadmin/facilities/${facilityId}/patientTypes/${patientTypeId}/updateFromPackage/${packageId}`,
  careTeams: `/api/org/careteams`,
  reInvitePatient: (patientId) => `/api/staff/patients/${patientId}/reinvite`,
  reInviteStaff: (staffId) => `/api/org/staff/${staffId}/reinvite`,
  mpsPackageDuplicate: (id, name) =>
    `/api/mpsadmin/mpspackages/${id}/cloneWithName/${name}`,
  mpsPackages: `/api/mpsadmin/mpspackages`,
  carePlanAsCSV: (patientId) => `/api/staff/patients/${patientId}/careplan-csv`,
  fireCompleteCarePlan: (patientId) =>
    `/api/staff/patients/${patientId}/fire-complete-careplan`,
  tagPatient: (patientId) => `/api/staff/mypatients/${patientId}`,
  restorePatient: (patientId) => `/api/staff/patients/${patientId}/reenable`,
  allSpaces: `/api/spaces?allStatus=true`,
  changeSpace: (newSpaceId) => `api/spaces/${newSpaceId}/currentspace`,
  editFacilityAdmin: (facilityId, staffId) =>
    `/api/mpsadmin/facilities/${facilityId}/admin/${staffId}`,
  taskTemplates: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/tasktemplates`,
  taskTemplatesWoPatientTypeId: () => `/api/artifact/tasktemplates`,
  taskTemplate: (patientTypeId, templateId) =>
    `/api/artifact/patienttypes/${patientTypeId}/tasktemplates/${templateId}`,
  tasks: (patientId) => `/api/staff/patients/${patientId}/tasks`,
  clinicTasks: (scheduleId) =>
    `/api/staff/clinicTasks?scheduleId=${scheduleId}`,
  myTasks: `/api/staff/inbox/mytasks`,
  allTasks: `/api/staff/inbox/tasks`,
  tasksCount: `/api/staff/tasks/count`,
  outbox: `/api/staff/outbox/mytasks`,
  question_appointments: `/api/admin/questionAppointments`,
  changePassword: `/api/updatePasswordOfLoggedInUser`,
  validateCarePlans: `/api/artifact/careplans/validate`,
  taskAssigneesForStaff: `/api/staff/staffandcareteams`,
  taskAssigneesForAdmin: `/api/org/staffandcareteams`,
  acceptTask: (taskId) => `/api/staff/tasks/${taskId}/accept`,
  completeTask: (taskId) => `/api/staff/tasks/${taskId}/complete`,
  reassignTask: (taskId) => `/api/staff/tasks/${taskId}/reassign`,
  task: (taskId) => `/api/staff/tasks/${taskId}`,
  executeTaskTemplate: (templateId, patientId) =>
    `/api/staff/tasktemplates/${templateId}/patients/${patientId}`,
  executeTaskTemplateForSchedule: (templateId, scheduleId) =>
    `/api/staff/tasktemplates/${templateId}/schedules/${scheduleId}`,
  facilityPatientStats: (facilityId) =>
    `/api/mpsadmin/facilities/${facilityId}/stats`,
  facilityAssignedPackages: (facilityId) =>
    `/api/mpsadmin/facilities/${facilityId}/mpspackages`,
  patientsWithBasicDetails: `/api/staff/patients/light`,
  addPackage: (facilityId, packageId) =>
    `/api/mpsadmin/facilities/${facilityId}/addNewPackage/${packageId}`,
  patientMembers: "/api/patient/members",
  patientDocuments: "/api/patient/artifacts?artifactType=PATIENT_DOCUMENTS",
  addDocument: (patientId, sendAsStatusMessage = false) =>
    `/api/staff/patients/${patientId}/assignDocument/?sendAsStatusMessage=${sendAsStatusMessage}`,
  patientDevices: "/api/patient/artifacts?artifactType=DEVICES",
  uiAttributesForFields: "/api/artifact/allUIFields",
  fieldsConfig: "/api/artifact/attributeUIFields",
  masterData: "/api/artifact/masterdata",
  masterDataAllRoles: "/api/masterdata",
  masterDataEdit: (id) => `/api/artifact/masterdata/${id}`,
  reopenTask: (id) => `/api/staff/tasks/${id}/reopen`,
  availableFeatures: `/api/mpsadmin/getAllAvailableFeatures`,
  facilitiesAndPatientTypes: `/api/mpsadmin/packageHelperPatientTypes?withoutPackages=true`,
  changeLogs: (patientId) =>
    `/api/staff/patients/${patientId}/logs?auditType=CHANGE_LOG`,
  accessLogs: (patientId) =>
    `api/staff/patients/${patientId}/logs?auditType=ACCESS_LOG`,
  archiveChangeLogs: (patientId) =>
    `/api/staff/patients/${patientId}/logs/archive`,
  // patientStats: `/api/artifact/v1/getPatientData`,
  patientStats: `/api/artifact/v2/getPatientData`,
  surveyResponse: (patientId, messageId) =>
    `/api/staff/patients/${patientId}/messages/${messageId}/surveyresponses`,
  directSurveyResponse: (patientId) =>
    `/api/staff/patients/${patientId}/surveyresponses`,
  taskUserParameters: `/api/artifact/taskUserParameters`,
  campaigns: "/api/artifact/campaigns",
  sendToPatient: "/api/staff/sendToPatient",
  bulkActionRequests: "/api/staff/bulk-action-requests",
  bulkUploadFiles: "/api/bulkUploadFiles",
  bulkUploadFilesStatus: (jobId) => `/api/bulkUploadFiles/status/${jobId}`,
  deleteFacilityOTP: (facilityId) =>
    `/api/mpsadmin/facilities/${facilityId}/getotp`,
  deleteFacility: (facilityId, OTP) =>
    `/api/mpsadmin/facilities/${facilityId}/withotp/${OTP}`,
  allResmedLocations: `/api/admin/mps/meta?type=LOCATIONS`,
  resmedUsers: (locId) =>
    `/api/admin/mps/meta?type=CLINICAL_USERS&locId=${locId}`,
  detailedAssessmentReport: (patientId) =>
    `/api/staff/patients/${patientId}/detailedReport`,
  therapyComplianceReport: (patientId) =>
    `/api/staff/patients/${patientId}/therapyComplianceReport`,
  mpsAdminPatientStats: (facilityId) =>
    `api/mpsadmin/facilties/${facilityId}/v2/getPatientData`,
  restoreStaff: (staffId) => `/api/admin/staff/${staffId}/undelete`,
  resetStaffPassword: (staffId) =>
    `/api/org/staff/${staffId}/setLoginCredentials`,
  carePlanAsHTML: (carePlanId) =>
    `/api/artifact/careplans/export/${carePlanId}/compressed`,
  exportPatientTypePackage: (patientTypeId) =>
    `/api/artifact/patientTypes/${patientTypeId}/mpspackages/export`,
  importPatientTypePackage: "/api/artifact/mpspackages/import?",
  allTaskTemplates: "/api/artifact/tasktemplates",
  staffTaskReport: "/api/staff/report/tasks",
  staffTaskReportTasks: "/api/staff/report/getTasks",
  taskAssigneesForTaskReport: `/api/staff/report/staffandcareteams`,
  previewInviteReminder: `/api/admin/remindForInvite`,
  previewInactivityReminder: `/api/admin/remindForInActivity`,
  previewSurveyCompletionReminder: `/api/admin/remindForSurveyIncompletion`,
  dbStats: (facilityId) => `/api/mpsadmin/facilities/${facilityId}/dbStats`,
  mpsAdminTemplateParameters: `/api/mpsadmin/messageparameters`,
  challengeFields: (code) => `/api/signup/fetchChallengeFields/${code}`,
  challengeFieldsFromFacilityCode: (code) =>
    `/api/signup/fetchChallengeFieldsFromFacilityCode/${code}`,
  fetchAddPatientProfileFromCode: (code) =>
    `/api/signup/fetchAddPatientProfileFromCode/${code}`,
  reminderAudits: `/api/admin/getReminderAuditLog`,
  acceptInviteV1: `/api/signup/v1/acceptInvite`,
  setLoginCredentialsV1: `/api/signup/v1/setLoginCredentials`,
  resetPatientCredentials: (patientId) =>
    `/api/staff/patients/${patientId}/setLoginCredentials`,
  activatePatient: (patientId) =>
    `/api/staff/patients/${patientId}/activatePatient`,
  staffStats: `/api/artifact/getStaffData`,
  masterDataCSVUpload: `/api/artifact/masterdataFromCSV`,
  mpsAdminStaffStats: (facilityId) =>
    `/api/mpsadmin/facilties/${facilityId}/getStaffData`,
  mpsAdminArtifactsStats: (facilityId) =>
    `/api/mpsadmin/facilties/${facilityId}/getArtifactsUsages`,
  artifactsStats: `/api/artifact/getArtifactsUsages`,
  patientSignUp: `/api/signup/patients`,
  emailConfirmation: (code) => `/api/signup/confirm/${code}`,
  signUpValidation: `/api/signup/validate`,
  signupProfileFromCode: (code) => `/api/signup/fetchProfileFromCode/${code}`,
  statusById: (patientId, statusId) =>
    `/api/staff/patients/${patientId}/status/${statusId}`,
  documentById: (patientId, docId) =>
    `/api/staff/patients/${patientId}/patientDocuments/${docId}`,
  loadLibForSignUp: (libId, locale) =>
    `api/signup/libraries/${libId}?locale=${locale}`,
  MPSAdminPatients: () => `/api/mpsadmin/patients`,
  MPSAdminPatientDSAR: (facilityId, patientId) =>
    `/api/mpsadmin/facilities/${facilityId}/patients/${patientId}/dsar`,
  MPSSupportPatients: () => `/api/mpssupport/patients`,
  MPSSupportPatientDSAR: (facilityId, patientId) =>
    `/api/mpssupport/facilities/${facilityId}/patients/${patientId}/dsar`,
  mpsAdminAuditLogs: "/api/mpsadmin/auditlogs",
  markStatusAsRead: `/api/patient/setMessagesAsRead`,
  loadPersonalNotes: (patientId) =>
    `/api/staff/patients/${patientId}/artifacts?artifactType=PERSONAL_NOTES`,
  loadPatientInteractions: (patientId) =>
    `/api/staff/patients/${patientId}/artifacts?artifactType=INTERACTIONS`,
  patientCustomReport: (patientId) =>
    `/api/staff/patients/${patientId}/getCustomReport`,
  getPatientComorbidities: (patientId) =>
    `/api/staff/patients/${patientId}/comorbidityProfile`,
  addPatientComorbidity: (patientId) =>
    `/api/staff/patients/${patientId}/comorbidities`,
  deletePatientComorbidity: (patientId, comorbidityId) =>
    `/api/staff/patients/${patientId}/comorbidities/${comorbidityId}`,
  patientCustomReportTab: (patientId, tabId) =>
    `/api/staff/patients/${patientId}/getCustomReport?tabId=${tabId}`,
  patientCustomReportAnonymous: (patientTypeId) =>
    `/api/admin/getCustomReport?pTypeId=${patientTypeId}`,
  appointmentSchedule: `/api/artifact/schedules`,
  appointments: `/api/artifact/appointments`,
  appointmentsCalendar: `/api/artifact/appointments/calendar`, // Lightweight calendar API
  appointmentSeriesPreview: (patientId) =>
    `/api/staff/patients/${patientId}/aseries/preview`,
  appointmentSeries: (patientId) => `/api/staff/patients/${patientId}/aseries`,
  appointmentStartNotification: (appointmentId) =>
    `api/artifact/appointments/${appointmentId}/sendLinkNotification`,
  slots: `/api/artifact/slots`,
  scheduleSlots: (scheduleId) => `/api/artifact/schedules/${scheduleId}/slots`,
  appointmentTemplates: `/api/artifact/appttemplates`,
  unsubscribe: `/api/signup/unsubscribe`,
  provisionedSurveys: (patientId) =>
    `/api/staff/patients/${patientId}/artifacts?artifactType=PROVISIONED_SURVEYES`,
  preferredLocale: (locale) => `/api/locales/${locale}`,
  staffSpecialNoteForPatient: (patientId) =>
    `/api/staff/patients/${patientId}/setSpecialNote`,
  videoRoom: (patientId, type, roomType) =>
    `/api/staff/patients/${patientId}/videoRooms?type=${type}` +
    (roomType ? `&roomType=${roomType}` : ""),
  joinRoom: (roomName) => `/api/signup/joinRooms/${roomName}`,
  joinRoomAuth: (roomName) => `/api/joinVideoRooms/${roomName}`,
  patientContacts: (patientId) =>
    `/api/staff/patients/${patientId}/contactpersons`,
  appointmentsFromTemplate: `/api/artifact/appointmentsFromTemplate`,
  videoRoomDetails: (roomName) => `/api/videoRooms/${roomName}/status`,
  videoRoomTranscript: (patientId, roomName) =>
    `/api/staff/patients/${patientId}/videoRooms/${roomName}/transcript`,
  patientsImportCSV: (patientTypeId) =>
    `/api/staff/patients/fromcsv?patientTypeId=${patientTypeId}`,
  unjoinRoomAuth: (roomName) => `/api/unjoinVideoRooms/${roomName}`,
  addPatientAsChannel: () => `/api/staff/patients/aschannel`,
  careTeamsForAll: () => `/api/careteams`,
  importStaff: () => `/api/org/staff/fromcsv`,
  usageCounters: () => `/api/artifact/usageCounters`,
  carePlansByPatientTypeAndPatientId: (patientTypeId, patientId) =>
    `/api/artifact/careplans/patienttypes/${patientTypeId}?patientId=${patientId}`,
  patientSubmittedSurveys: (patientId, flag) =>
    `/api/staff/patients/${patientId}/assessments${flag}`,
  patientSurveysResponsesById: (patientId, surveyId, page, size, flag) =>
    `/api/staff/patients/${patientId}/surveys/${surveyId}?page=${page}&size=${size}${flag}`,
  savedPatientQueries: `/api/artifact/savedSearches`,
  savedPatientQueriesOrder: `/api/artifact/savedSearches/order`,
  publishedSchedules: `/api/artifact/publishedSchedules`,
  rules: (patientTypeId) =>
    `/api/artifact/patientTypes/${patientTypeId}/ruleMaps`,
  sendMessageToPatients: () => `/api/artifact/sendMessageToPatients`,
  getEpisodesOfCare: (patientId) => `/api/staff/patients/${patientId}/episodes`,
  runRuleMap: (patientTypeId, ruleMapId) =>
    `/api/artifact/patientTypes/${patientTypeId}/processRules/${ruleMapId}`,
  interactions_report: (patientId) =>
    `api/staff/patients/${patientId}/artifacts?artifactType=INTERACTIONS_REPORT&page=0&size=100`,
  anonAppointment: (appointmentId) =>
    `/api/signup/appointments/${appointmentId}`,
  appointmentAudits: (appointmentId) =>
    `/api/artifact/appointments/${appointmentId}?showLogs=true`,
  addPatientScreen: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/screens/addpatient`,
  addPatientV2: `/api/staff/v2/patients`,
  patientInfoPanel: (patientTypeId, exportContent) =>
    `/api/artifact/patienttypes/${patientTypeId}/patientinfopanel?${
      exportContent ? "exportContent=true" : ""
    }`,
  patientInfoPanelGenerated: (patientTypeId) =>
    `api/artifact/patienttypes/${patientTypeId}/generateInfoPanelForPatientDefnOp`,
  staffInfoPanelView: `/api/artifact/generateInfoPanelForStaff`,
  staffInfoPanel: (isExport, isImport) =>
    `api/artifact/staffinfopanel${isExport ? "?exportContent=true" : ""}${
      isImport ? "?importContent=true" : ""
    }`,
  patientAppointments: (patientId, pageNumber, pageSize) =>
    `/api/artifact/appointments?patientId=${patientId}&page=${pageNumber}&size=${pageSize}`,
  appointmentAttributes: `/api/artifact/appointmentAttributes`,
  apptattributes: `/api/artifact/apptattributes`,
  clinics: (clinicId) => `/api/staff/clinics${clinicId ? "/" + clinicId : ""}`,
  clinicColumns: `/api/artifact/clinicColumns`,
  appointmentsImportCSV: () => `/api/staff/appointments/fromcsv`,
  patientAsCSV: (patientTypeId) =>
    `/api/admin/patientTypes/${patientTypeId}/allPatientsReport?`,
  staffPatientExport: () => `/api/staff/v1/patients/export`,
  clearCarePlanHistory: (patientId) =>
    `/api/staff/patients/${patientId}/clear-careplan-history`,
  recordPhoneCall: (patientId) =>
    `api/staff/patients/${patientId}/recordPhoneCall`,
  loadNotesSummary: (patientId) =>
    `api/artifact/${patientId}/staffNotesSummary`,
  revertAppointmentCancel: (appointmentId) =>
    `/api/artifact/appointments/${appointmentId}/undelete`,
  ruleLogs: (patientTypeId, ruleId) =>
    `/api/artifact/patienttypes/${patientTypeId}/ruleLogs?ruleId=${ruleId}`,
  csvSchedules: () => `/api/artifact/schedules/fromcsv`,
  onboardingPatientDataTemplate: (patientId, type) =>
    `/api/signup/signupData?pId=${patientId}&type=${type}`,
  airViewNotes: (patientId) => `/api/staff/patients/${patientId}/airViewNotes`,
  clinicReports: () => `/api/staff/clinics/reports`,
  clinicUpdateStaffParticipants: (clinicId) =>
    `/api/staff/clinics/${clinicId}/participants`,
  clinicNotifyStaff: (clinicId, scheduleId, clinicDate) =>
    `/api/staff/clinics/${clinicId}/notify?scheduleId=${scheduleId}&clinicDate=${clinicDate}`,
  clinicReportsCSV: () => `/api/staff/clinics/reports-csv`,
  channel: (channelId) => `/api/staff/channels/${channelId}`,
  dialysisCenters: (patientId) =>
    `/api/staff/patients/${patientId}/dialysis-centers`,
  inviteOnboardingEvents: () => `/api/signup/events/invite`,
  // patientData: patientId => `/api/staff/patients/${patientId}/export-data`,
  patientData: (patientId) => `/api/staff/patients/${patientId}/dumpAll`,
  editPatientDocument: (patientId, docId) =>
    `/api/staff/patients/${patientId}/patientDocuments/${docId}`,
  clinicUploadReport: `/api/staff/csvLoadResults`,
  logout: () => `/api/logout`,
  reassignTasks: () => `/api/staff/tasks/reassign`,
  surveyResponses: (patientId, responseId) =>
    `/api/staff/patients/${patientId}/surveyresponses/${responseId}`,
  medications: (patientId) => `/api/staff/patients/${patientId}/medications`,
  importMedications: (patientTypeId) =>
    `/api/staff/patienttypes/${patientTypeId}/medications/fromcsv`,
  allergies: (patientId) => `/api/staff/patients/${patientId}/allergies`,
  patientTierSnapshots: (patientId) =>
    `/api/staff/patients/${patientId}/tiers`,
  patientNightData: (patientId) => `/api/staff/patients/${patientId}/nights`,
  foodJournalEntries: (patientId) =>
    `/api/staff/patients/${patientId}/diet/entries`,
  mfaStatus: () => `/api/setTwoFAStatus`,
  disableTwoFA: () => `/api/disableTwoFA`,
  resendOtp: () => `/api/a/resendOtp`,
  organizations: (orgId) => `/api/org/organizations${orgId ? "/" + orgId : ""}`,
  organizationStaff: (orgId, staffId) =>
    `/api/org/organizations/${orgId}/staff${staffId ? "/" + staffId : ""}`,
  roleTemplates: (roleId, noAllowForBulkReassigFlag) =>
    `/api/org/roleTemplates${roleId ? "/" + roleId : ""}${
      noAllowForBulkReassigFlag ? "" : "?allowForBulkReassign=true"
    }`,
  libraryExport: (libraryId) =>
    `/api/artifact/libraries/${libraryId}?exportContent=true`,
  surveyExport: (surveyId) =>
    `/api/artifact/surveys/${surveyId}?exportContent=true`,
  cloneLibrary: (libId) => `/api/artifact/libraries/${libId}/clone`,
  facilityDocuments: (docId) =>
    `/api/artifact/documents${docId ? "/" + docId : ""}`,
  carePlanClone: (id) => `/api/artifact/careplans/${id}/clone`,
  apptTemplateClone: (id) => `/api/artifact/appttemplates/${id}/clone`,
  consentClone: (id) => `/api/artifact/consentDocuments/${id}/clone`,
  ruleClone: (patientTypeId, ruleId) =>
    `/api/artifact/patientTypes/${patientTypeId}/ruleMaps/${ruleId}/clone`,
  externalIntegrations: () => `/api/admin/externalIntegrations`,
  supportStaff: (staffId) =>
    `/api/mpsadmin/support${staffId ? "/" + staffId : ""}`,
  supportPatients: () => `/api/support/patients`,
  getAllFacilitiesForSupport: () => "/api/support/facilities",
  resetPatientCredentialsBySupport: (patientId) =>
    `/api/support/patients/${patientId}/setLoginCredentials`,
  loadSupportStaffProfile: () => "/api/support/",
  commonMasterData: "/api/mpsadmin/masterdata",
  hcpReport: () => `/api/admin/hcp-monthly-report`,
  billingReport: (start) => `/api/admin/getBillingReportOp?start=${start}`,
  identifySelfSignupPatient: () => `/api/signup/identifySelfSignupPatient`,
  setLoginCredentialsV2: `/api/signup/v2/setLoginCredentials`,
  embeddedReports: (workspaceId, reportId) =>
    `/api/artifact/reports/embedded?workspaceId=${workspaceId}&reportId=${reportId}`,
  downloadEmbeddedReports: (workspaceId, reportId) =>
    `/api/artifact/reports/embedded/download?workspaceId=${workspaceId}&reportId=${reportId}`,
  reportIntegrations: () => `/api/artifact/reports/integrations`,
  subOrganizations: (orgId) => `/api/org/organizations?parentOrgId=${orgId}`,
  userEvents: () => `/api/user-events`,
  chargeItems: (patientId) => `/api/staff/patients/${patientId}/chargeItems`,
  actions: (patientTypeId) =>
    `/api/artifact/actions?${
      patientTypeId ? "patientTypeId=" + patientTypeId : ""
    }`,
  action: (actionId) => `/api/artifact/actions/${actionId}`,
  newsLetter: (id) =>
    `/api/admin/newsletter/configuration${id ? "/" + id : ""}`,
  getSurveyByName: (surveyName) => `/api/surveys?name=${surveyName}`,
  surveyResponsesCSV: (patientId, surveyId) =>
    `/api/staff/patients/${patientId}/surveys/${surveyId}/csv`,
  deleteInactiveUsers: (facilityId, otp) => {
    if (otp) {
      return `/api/mpsadmin/allusers/${facilityId}/withotp/${otp}`;
    } else {
      return `/api/mpsadmin/allusers/${facilityId}/getotp`;
    }
  },
  patientQuickActions: () => `/api/admin/quick-actions/patient`,
  forceRelogin: () => `/api/forceRelogin`,
  accessTokensAuth: (type) => `/api/video-call/tokens?type=${type}`,
  accessTokens: (type, roomName) =>
    `/api/a/video-call/tokens?type=${type}&roomName=${roomName}`,
  accessTokenFromCode: (type, code) =>
    `/api/staff/access-token?type=${type}&code=${code}`,
  addVideoParticipants: () => `/api/staff/video-calls/add-participants`,
  endVideoCall: () => `/api/staff/end-video-call`,
  revokeWebexAccess: () => `/api/staff/webexauth`,
  patientSurveyImportFromCSV: (survey) =>
    `api/staff/assessments/${survey}/fromcsv`,
  adherenceReport: () => `/api/artifact/adherenceReport`,
  hseAdherenceReport: () => `/api/artifact/v1/adherenceReport`,
  sendConversationReadStaff: (patientId, messageId) =>
    `api/staff/patients/${patientId}/setMessagesAsRead?parentMessageId=${messageId}`,
  fetchAGPData: (patientId, fromDate, toDate, surveyName) => {
    let url = `/api/staff/patients/${patientId}/agp`;
    const params = new URLSearchParams();
    if (fromDate && toDate) {
      fromDate = convertDateFormat(fromDate);
      toDate = convertDateFormat(toDate);
      params.append("fromDate", fromDate);
      params.append("toDate", toDate);
    }
    if (surveyName) {
      params.append("surveyName", surveyName);
    }
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
    return url;
  },
  getObservationHistory: (patientId, observationCode) =>
    `/api/staff/patients/${patientId}/observations?observationCode=${observationCode}`,
  patientGetObservationHistory: (observationCode) =>
    `/api/patient/observations?observationCode=${observationCode}`,
  chat: () => `/api/chat`,
  addChatConfig: (typeId) => `/api/artifact/patienttypes/${typeId}/chatConfig`,
  createContent: `/api/copilot/content`,
  externalSurveyResponse: (patientId) => `/api/a/survey?p=${patientId}`,
  episodeOfCareTemplates: (patientTypeId) =>
    `/api/artifact/episodeofcaretemplates/${patientTypeId}`,
  addEpisodeOfCare: (patientId) => `/api/staff/patients/${patientId}/episodes`,
  deleteEpisodeOfCare: (patientId, episodesId) =>
    `/api/staff/patients/${patientId}/episodes/${episodesId}`,
  editEpisodeOfCare: (patientId, episodesId) =>
    `/api/staff/patients/${patientId}/episodes/${episodesId}`,
  addSurveyWithAI: (patientTypeId) =>
    `/api/artifact/addSurveyFromPDF/${patientTypeId}`,
  getAttribute: (patientTypeId, patientId, attributeName) =>
    `api/artifact/patienttypes/${patientTypeId}/attributes/name/${attributeName}?patientId=${patientId}`,
  exportSurveyCSV: `/api/artifact/survey/exportsurveyCSV`,
  getAllCrews: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/crews`,
  updateCrew: (patientTypeId, crewId) =>
    `/api/artifact/patienttypes/${patientTypeId}/crews/${crewId}`,
  deleteCrew: (patientTypeId, crewId) =>
    `/api/artifact/patienttypes/${patientTypeId}/crews/${crewId}`,
  createCrew: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/crews/full`,
  exportStaffDetails: `/api/admin/staff/reportAll`,
  goals: (patientId) => `/api/staff/patients/${patientId}/goals`,
  goalTemplates: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/goalTemplates`,
  goalFromTemplate: (patientId, goalId) =>
    `/api/staff/patients/${patientId}/goalTemplates/${goalId}/goal`,
  createPatientSummary: (patientId) =>
    `/api/artifact/${patientId}/createPatientSummary`,
  savePatientSummary: (patientId) =>
    `/api/artifact/${patientId}/savePatientSummary`,
  getStaffLogs: "/api/admin/stafflogs",
  getArtifactLogs: "/api/admin/artifactlogs",
  getAssistants: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/assistants/list`,
  deleteAssistant: (patientTypeId, assistantId) =>
    `/api/artifact/patienttypes/${patientTypeId}/assistants/${assistantId}`,
  updateAssistant: (patientTypeId, assistantId) =>
    `/api/artifact/patienttypes/${patientTypeId}/assistants/${assistantId}`,
  createAssistants: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/assistants`,
  getReactAgents: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/reactagents`,
  deleteReactAgent: (patientTypeId, reactAgentId) =>
    `/api/artifact/patienttypes/${patientTypeId}/reactagents/${reactAgentId}`,
  updateReactAgent: (patientTypeId, reactAgentId) =>
    `/api/artifact/patienttypes/${patientTypeId}/reactagents/${reactAgentId}`,
  createReactAgent: (patientTypeId) =>
    `/api/artifact/patienttypes/${patientTypeId}/reactagents`,
  smartSchedulers: (patientTypeId) =>
    `/api/artifact/patientTypes/${patientTypeId}/smartSchedulers`,
  appointmentAddOns: (patientTypeId) =>
    `/api/artifact/patientTypes/${patientTypeId}/appointmentAddOns`,
  contentIndexStatus: (patientTypeId) =>
    `/api/admin/contentIndex/${patientTypeId}/status`,
  contentIndexStatusAll: () => `/api/admin/contentIndex/status`,
  contentIndexReindex: (patientTypeId) =>
    `/api/admin/contentIndex/${patientTypeId}/reindex`,
  contentIndexReindexFacility: () =>
    `/api/admin/contentIndex/facility/reindex`,
  // Terminology Server
  terminologyStatus: "/api/terminology/status",
  terminologySearch: (type) => `/api/terminology/search/${type}`,
  terminologyLookup: (type) => `/api/terminology/lookup/${type}`,
  // Governance review packs
  governanceReviewPacks: (patientTypeId) =>
    `/api/admin/patientTypes/${patientTypeId}/governance-review-packs`,
  governanceReviewPack: (packId) => `/api/admin/governance-review-packs/${packId}`,
  governanceReviewPackXlsx: (packId) =>
    `/api/admin/governance-review-packs/${packId}/xlsx`,
  governanceReviewPackPdf: (packId, domains) =>
    `/api/admin/governance-review-packs/${packId}/pdf${
      domains && domains.length ? `?domains=${domains.join(",")}` : ""
    }`,
  terminologyValidate: (type) => `/api/terminology/validate/${type}`,
  terminologyBatchLookup: (type) =>
    `/api/terminology/batch/lookup/${type}`,
  terminologyMedicationLookup: "/api/terminology/medication-lookup",
  terminologyObservationCategory: "/api/terminology/observation-category",
  terminologyObservationSetSuggest: "/api/terminology/observation-sets/suggest",
  terminologyObservationSetBulkCreate: "/api/terminology/observation-sets/bulk-create",
  terminologyPathwayPacks: "/api/terminology/observation-sets/packs",
  terminologyPathwayPackByKey: (key) =>
    `/api/terminology/observation-sets/packs/${encodeURIComponent(key)}`,
  terminologyTranslate: (from, to) =>
    `/api/terminology/translate/${from}-to-${to}`,
  // MYP-8760: read-only holiday lookup, routed like updateFacility (MPS admin vs facility admin)
  lookupFacilityHolidays: (role, id) =>
    role === ROLE_MPS_ADMIN
      ? `/api/mpsadmin/facilities/${id}/holidays/lookup`
      : `/api/admin/facility/holidays/lookup`,
};

export const PATIENT_API_ENDPOINTS = {
  uploadDocument: "/api/patient/documents",
  getPatientCustomHomeScreenConfig: "/api/patient/getCustomReport",
  activitiesForTodayCount: "/api/patient/careplan/activitiesForTodayCount",
  unreadMessagesCount: "/api/patient/careplan/unreadMessagesCount",
  appointmentsCount: "/api/patient/appointmentsCount",
  getPatientMessage: (messageId) => `api/patient/messages/${messageId}`,
  getLibraryTopics: `api/librarytopics?page=0&size=1000`,
  patientLibraries: "/api/patient/libraries",
  librariesList: "/api/patient/libraries/list",
  carePlan: "/api/patient/careplan/",
  patientProfile: "/api/patient/profile",
  updateProfileAttribute: "/api/patient/profile/attributes",
  statusMessages: "/api/patient/artifacts?artifactType=STATUSES_NEW",
  agentStatuses: "api/patient/artifacts?artifactType=AGENT",
  surveyResponses: "/api/patient/artifacts?artifactType=SURVEY_RESPONSES",
  tasks: "/api/patient/tasks",
  provisionedSurveys:
    "/api/patient/artifacts?artifactType=PROVISIONED_SURVEYES",
  infoPanel: "/api/patient/informationPanel",
  sendPatientConversation: (messageId) =>
    `/api/patient/messages/${messageId}/conversation`,
  sendStaffConversation: (patientId, messageId) =>
    `api/staff/patients/${patientId}/messages/${messageId}/conversation`,
  sendConversationRead: (messageId) =>
    `api/patient/setMessagesAsRead?parentMessageId=${messageId}`,
  consentSubmission: (messageId, consentId) =>
    `/api/patient/messages/${messageId}/consents/${consentId}`,
  surveyResponse: (messageId) =>
    `/api/patient/messages/${messageId}/surveyresponses`,
  appointmentSchedule: (scheduleId) => `/api/signup/schedules/${scheduleId}`,
  createAppointmentFromTemplate: () => `api/signup/appointmentsFromTemplate`,
  groupCalls: (userId, patientId, scheduleId) =>
    `/api/signup/confcallappointments?page=0&size=1000&uid=${userId}&pid=${patientId}&appScheduleId=${scheduleId}`,
  joinGroupCall: (userId, patientId) =>
    `/api/signup/joinConfCall?uid=${userId}&pid=${patientId}`,
  slots: `/api/signup/slots`,
  futureAppointments: `/api/patient/appointments`,
  appointments: `/api/patient/appointments`,
  submittedSurveys: `/api/patient/assessments`,
  surveys: `/api/patient/surveys`,
  surveysResponsesById: (surveyId, page, size) =>
    `/api/patient/assessments/${surveyId}?page=${page}&size=${size}`,
  taskTemplates: `/api/patient/tasktemplates`,
  taskFromTaskTemplate: (taskTemplateId) =>
    `/api/patient/tasktemplates/${taskTemplateId}`,
  carePlanProgress: `/api/patient/careplan/progress`,
  carePlanProgressChecklist: (patientId) =>
    `/api/staff/patients/${patientId}/careplan/progress`,
  medications: `/api/patient/medications`,
  allergies: `/api/patient/allergies`,
  surveyResponsesAdHoc: `/api/patient/surveyresponses`,
  appointmentScreening: (appointmentRefNumber, mrn) =>
    `/api/a/appointments/screening?appointmentRefNumber=${appointmentRefNumber}&mrn=${mrn}`,
  topicsFromMasterData: (id, type) =>
    `/api/masterdata/topics?${id ? `pTypeid=${id}` : ""}&topicType=${type}`,
  actions: () => `/api/actions/execute`,
  anonInfoPanel: (code) => `/api/a/info-panel?ca=${code}`,
  anonLib: (libId, code) => `/api/a/library/${libId}?ca=${code}`,
  regWithings: () => `/api/patient/withings/register`,
  chat: () => `/api/patient/chat`,
  transcribeAudio: () => `/api/patient/transcribeAudio`,
  sendAudioToAgent: () => `/api/patient/agent`,
  addAgentStatus: `/api/patient/status`,
  chatV2: () => `/api/chat/stream`,
  saveChatMessages: `/api/chat/messages`,
  loadChatMessages: `/api/chat/messages`,
  getAssistants: `/api/patient/assistants/list`,
  patientEvents: (patientId) => `/api/staff/${patientId}/events`,
  setPatientProfilePhoto: `/api/patient/setPatientProfilePhoto`,
  dietUpload: "/api/patient/diet/upload",
  dietEntries: "/api/patient/diet/entries",
  dietEntry: (id) => `/api/patient/diet/entries/${id}`,
  dietDishes: "/api/patient/diet/dishes",
};

export const PAGE_SIZE = 20;

export function getServerRegions() {
  return [].concat(Env);
}

export function getAppURL() {
  return getEnvValue("appURL");
}

function setDefaultAPIURL() {
  let url = getAPIURL();
  /*console.log("[ENV DEBUG] Setting default API URL:", {
    detectedRegion: getRegionFromDomain(),
    currentDomain: document.domain,
    resolvedURL: url,
    windowLocation: window.location.href,
  });*/
  http.setBaseURL(url);
  StorageService.addToLocalStorage(API_URL_KEY, url);
}

export function getAPIURL() {
  let region = null;
  if (window.location.search) {
    let params = parseURLQueryParams(window.location.search);
    if (params && params.region) {
      region = params.region;
    }
  }

  let url = null;
  if (region) {
    url = getEnvValue("url", region);
  } else if (document.domain === "localhost") {
    // For localhost, always use environment detection instead of localStorage
    url = getEnvValue("url");
  } else if (StorageService.getFromLocalStorage(API_URL_KEY)) {
    url = StorageService.getFromLocalStorage(API_URL_KEY);
  }

  if (!url) {
    url = getEnvValue("url");
  }
  return url;
}

setDefaultAPIURL();

function getEnvValue(field, region) {
  if (!region) {
    region = getRegionFromDomain();
  }
  let filtered = Env.filter((host) => host.regionCode === region);
  /*console.log("[ENV DEBUG] getEnvValue lookup:", {
    field,
    region,
    allEnvs: Env,
    filtered,
    foundValue: filtered && filtered[0] ? filtered[0][field] : null,
    fallbackValue: Env[0][field],
  });*/
  let value = filtered && filtered[0] ? filtered[0][field] : null;
  value = value || Env[0][field];
  return value;
}

function getRegionFromDomain() {
  let regionMapping = {
    "web.mypatientspace.com": "prod",
    // "latam.mypatientspace.com": "prod",
    "uat.mypatientspace.com": "uat",
    "uae.mypatientspace.com": "uae",
    "test.mypatientspace.com": "testweb",
    "preprod.mypatientspace.com": "preprod",
    "melanomaireland.ie": "prod",
  };

  // For localhost, dynamically detect the current backend selection
  if (document.domain === "localhost") {
    // Check if there's a stored API URL that can tell us which backend is selected
    const storedApiUrl = StorageService.getFromLocalStorage(API_URL_KEY);
    if (storedApiUrl) {
      // Map API URLs back to region codes
      const urlToRegionMapping = {
        "https://api.mypatientspace.com": "prod",
        "https://testapi.mypatientspace.com": "testweb",
        "https://uatapi.mypatientspace.com": "uat",
        "https://uaeapi.mypatientspace.com": "uae",
        "https://preprodapi.mypatientspace.com": "preprod",
        "http://localhost:8080": "lo",
      };

      const detectedRegion = urlToRegionMapping[storedApiUrl];
      if (detectedRegion) {
        /*console.log("[ENV DEBUG] Localhost detected backend from storage:", {
          storedApiUrl,
          detectedRegion,
        });*/
        return detectedRegion;
      }
    }

    // If no stored URL, check URL params for region override
    if (window.location.search) {
      let params = parseURLQueryParams(window.location.search);
      if (params && params.region) {
        /*console.log(
          "[ENV DEBUG] Localhost using URL param region:",
          params.region
        );*/
        return params.region;
      }
    }

    // Default fallback for localhost — use LOCAL backend
    return "lo";
  }

  return regionMapping[document.domain] || "testweb";
}

export function isTest() {
  return (
    document.domain === "preprod.mypatientspace.com" ||
    document.domain === "testweb.mypatientspace.com" ||
    document.domain === "localhost"
  );
}

function convertDateFormat(dateString) {
  // Split the input date string into components
  let [day, month, year] = dateString.split("-");

  // Return the date in the desired format
  return `${year}${month}${day}`;
}

export const WEBEX_OAUTH_URL = "https://webexapis.com/v1/authorize";
